import {authService} from './../services/authService';
import { getDistance } from 'geolib';


export const loading = (isLoading) =>  {
    return({
        type:"APP_LOADING",
        isLoading:isLoading
    });
};

export const addAttendanceLogs = (data) =>{
    return{
        type:"ADD_ATTENDANCE_LOGS",
        attendanceLogs: data
    };
}
export const clearAttendanceLogs = () => {
    debugger;
    return ({
        type:"CLEAR_ATTENDANCE_LOGS"
    });
}

export const addAttendanceLog = (data) =>{
    return{
        type:"ADD_ATTENDANCE_LOG",
        attendanceLog: data
    };
}
export const startAddAddendaceLog = (data) => {
    return async dispatch => {
        try{
            debugger;
            const attendance = await authService.request({
                method:"POST",
                url:"/api/AttendanceLogAPI/AddAttendanceLog",
                data
            });
    
            return dispatch(addAttendanceLog(attendance.Data));
        }
        catch(error){
            throw(error);
        }
        
    }
}

export const getAttendanceLogs = (personnelId,fromDate,toDate) =>{
    return async dispatch => {
        try{
            dispatch(clearAttendanceLogs());
            return dispatch(addAttendanceLogs(await authService.request({
                method :"GET",
                url :"/api/AttendanceLogAPI/GetAttendanceLogs",
                params:{
                    fromDate:fromDate,
                    toDate:toDate,
                    attendanceTypeValue:51
                }
            })));
        }catch(error){
            throw(error);
        }
    }
}
export const getUserWorkplace = (data) => {
    return async dispatch => {
        return dispatch(addUserWorkplace(await authService.request({
            method:"GET",
            url : "/api/WorkplaceAPI/GetMyWorkplaces"
        })));
    }
}
export const addUserWorkplace = (data) => {
    return{
        type:"ADD_USER_WORKPLACE",
        userWorkplace: data
    }
}
export const isUserInWorkplace = (location,userWorkplaces) =>{
    let userInWorkplace = false;
    let userWorkplace;
    const loc = {
        latitude:location.coords.latitude, 
        longitude:location.coords.longitude
    }
    try{
        for(let i = 0 ;i<userWorkplaces.length;i++){
            debugger;
            const {Latitude:latitude,Langitude:longitude}= userWorkplaces[i];
            const distance = getDistance(loc, {latitude,longitude})
            if(distance<userWorkplaces[i].Radius+100 && userWorkplaces[i].Recorders[0].Type.Value ==='11001'){
                userWorkplace = userWorkplaces[i];
                userInWorkplace = true;
                break;
            }
            if(userWorkplaces[i].Recorders[0].Type.Value ==="11004"){
                userWorkplace = userWorkplaces[i];
                userInWorkplace = true;
                break;
            }
        }
        
        if(userInWorkplace){
            return{
                type:"USER_IN_WORKPLACE",
                userInWorkplace,
                userWorkplace
            }
        }else{
            return{
                type:"USER_IN_WORKPLACE",
                userInWorkplace:false
            }
        }
       
      
    }catch(error){
        
    }

    
}